import * as React from 'react';

import noop from 'lodash/noop';

import { getImageURL } from '../../../../utils';
import { getImage } from '../../../../services/media';
import { open as openMediaPicker } from '../../../../services/media-picker';
import { translate as t } from '../../../../translations';
import { Icon } from '@lumapps/lumx/react';
import { mdiDelete, mdiImage, mdiPencil } from '@lumapps/lumx/icons';

/**
 * Renders a single image thumbnail that can be updated by clicking on it.
 *
 * Requires the `<reusable-media-picker />` directive to be present in the DOM somewhere.
 */
export class ImageChooser extends React.PureComponent {
    constructor(props) {
        super(props);
        const onChange = (value) => this.props.onChange(value, this.props.name);
        this.openMediaPicker = () => openMediaPicker(this.props.value, onChange);
        this.deleteImage = (evt) => {
            evt.stopPropagation();
            onChange(undefined);
        };
    }

    render() {
        const { value, style = {} } = this.props;

        return (
            <div className="ls-media-manager image-chooser" onClick={() => (value ? noop() : this.openMediaPicker())}>
                <div className="uploader">
                    {value ? (
                        <div className="editable-media editable-media--edit-hover">
                            <div
                                className="editable-media__img editable-media__img--is-thumbnail"
                                style={{
                                    backgroundImage: getImageURL(getImage(value)),
                                    backgroundRepeat: 'no-repeat',
                                    backgroundSize: 'contain',
                                    ...style,
                                }}
                            />

                            <div className="editable-media__bar">
                                <div className="editable-media__label">
                                    <span>{t('STYLE.IMAGE')}</span>
                                </div>

                                <div className="editable-media__actions">
                                    <Icon icon={mdiPencil} onClick={this.openMediaPicker} />
                                    <Icon icon={mdiDelete} onClick={this.deleteImage} />
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="uploader__placeholder">
                            <Icon icon={mdiImage} />
                            <span>{t('SELECT_IMAGE')}</span>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
